module.exports = __webpack_public_path__ + "static/media/icon-key-big.0d56bc9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-key-big.svg
// module id = 1263
// module chunks = 19